import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Form } from 'semantic-ui-react'

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default function TandC(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const submitTerms=()=>{
    props.agreeMethod()
  }
  const close=()=>{
    setOpen(false);
  }
  return (
    <div>
      <Button color="secondary" onClick={handleClickOpen}>
        Click here to Agree with our Terms and Conditions to continue*
      </Button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle align="center" id="customized-dialog-title" onClose={handleClose}>
          COCENTRIC TERMS AND CONDITIONS
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
          AGREEMENT OF ASSOCIATION WITH COCENTRIC INDUSTRIAL SOLUTIONS LLP (As per Section 23(4) of the Limited Liability Partnership Act, 2008)
          This Agreement of LLP made in 2021 (THE FIRST & SECOND PARTY SHALL BE COLLECTIVELY REFERRED TO AS ASSOCIATES)
          IT IS HEREBY AGREED BY AND BETWEEN THE PARTIES HERETO AS FOLLOWS: <br/><br/>
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
              1.1]  VENDORWEB.IN  is a linking platform that connects Industries and enterprises  and it is    Operated by cocentric industrial solutions LLP.
            <br/><br/>
            1.2] With this agreement enterprise has given consensus to act as an associate of cocentric industrial solutions LLP
            <br/><br/>
            1.3] Associates and Cocentric will be working in collaboration to offer service to their customers.
            <br/><br/>
            1.4] All the work related information like payment terms , order value , period of service ,  will be shared by cocentric before engaging the associate with client.
            <br/><br/>
            1.5] Payment terms varies from client to client ranging from 7 days to 30 days /45 days , subjected to which cocentric will inform the associate with complete information.
            <br/><br/>
            1.6] Payment from cocentric to associate will be credited in associate account within 24 -48 working hours right after the  credit of  the payment  from client to cocentric.
            <br/><br/>
            1.7] Final credit of payment to associate will be done after taking cocentric charge  ranging from 1-5 % of total purchase order to associate. Credit of payment will include the order price + G.S.T
            <br/><br/>
            1.8] All the information will be shared from official mail ID- connect2cocentric@gmail.com
            <br/><br/>
            1.9] All the work related execution will be done by Associate where , Cocentric will assist in the operations .
            <br/><br/>
            1.10] Our Prime Customers will be Registered MNC which assures that there is no risk of fraudulent in payment , there might be certain circumstances that the payment will be delayed in a certain limit of time  from customer to cocentric industrial solutions LLP . If , cases arises where the payment credit from customers to Cocentric industrial solutions LLP crosses beyond limit , cocentric industrial solutions LLP is not liable to pay to associate meanwhile  associate is liable to take legal actions against customer  and  cocentric industrial solutions LLP will help the associate with legal team.
          </Typography>
        </DialogContent>
       <div align="center" className="p-4">
       <Form>
          <Form.Checkbox
            label='I agree to the terms and conditions'
            required
            checked={props.agreeValue}
            onClick={submitTerms}
          />
          {
            props.agreeValue ?
            <Button onClick={close} variant="contained" className="mt-2" color="primary">Click here to agree</Button>
            :
            <Button disabled variant="contained" className="mt-2" color="primary">Click here to agree</Button>
          }
        </Form>
       </div>
        
      </Dialog>
    </div>
  );
}
